// extracted by mini-css-extract-plugin
export var shake = "_j-1";
export var toastCloseButton = "_j-0";